
// use for endpoint slugs and as the object id in ldb
export enum OfflineTableId {
	DrugProduct = 'drug-product',
	DrugProductMap = 'drug-product-map',
	DrugSearchWord = 'drug-search-word',
	DrugIcd = 'drug-icd',
	MaterialInventory = 'material-inventory',
	DashboardNotification = 'dashboard-notification'
}
